export default "__VITE_ASSET__7de5dbba__"